// The one place a verdict is put into words, so the queue card, the selection
// bar and the hero page all confirm a decision the same way.

const PAST_TENSE = { approve: 'Approved', reject: 'Rejected' };

// A long title would push the reason off the end of the snackbar.
const MAX_NAME = 60;

function quoted(name) {
  const trimmed = (name || '').trim();
  if (!trimmed) return null;
  return trimmed.length > MAX_NAME ? `"${trimmed.slice(0, MAX_NAME - 1)}…"` : `"${trimmed}"`;
}

function asReason(reason) {
  return reason ? ` as ${reason}` : '';
}

// "approved" / "rejected", for a sentence that doesn't open on the verb.
export function verdictPastTense(kind) {
  return PAST_TENSE[kind].toLowerCase();
}

/**
 * A single verdict that landed. `name` falls back to the entity noun for an
 * entity with no title of its own.
 */
export function verdictResultMessage(kind, entity, name, reason = null) {
  return `${PAST_TENSE[kind]} ${quoted(name) || `the ${entity}`}${asReason(reason)}.`;
}

/**
 * A batch verdict that landed in full — a batch with failures reports those
 * instead, since a partial result is a warning rather than a confirmation.
 */
export function batchVerdictMessage(kind, entity, count, reason = null) {
  const noun = count === 1 ? entity : `${entity}s`;
  return `${PAST_TENSE[kind]} ${count} ${noun}${asReason(reason)}.`;
}
